import firebase_app from "../configs";
import {
  getAdditionalUserInfo,
  getAuth,
  signInWithPopup,
  OAuthProvider,
} from "firebase/auth";

const auth = getAuth(firebase_app);
const provider = new OAuthProvider("microsoft.com");
provider.setCustomParameters({
  prompt: "consent",
});
// INVALID_IDP_RESPONSE : Error getting verification code from microsoft.com response: error=invalid_request&error_description=The request is not valid for the application's 'userAudience' configuration. In order to use /common/ endpoint, the application must not be configured with 'Consumer' as the user audience. The userAudience should be configured with 'All' to use /common

export default async function signUpWithMicrosoft() {
  var user = null,
    error = null,
    userInfo = null,
    credential = null;
  try {
    await signInWithPopup(auth, provider)
      .then(async (result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        credential = OAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        user = result.user;
        userInfo = await getAdditionalUserInfo(result);
      })
      .catch((err) => {
        error = err;

        // Handle Errors here.
        // const errorCode = error.code;
        // const errorMessage = error.message;
        // // The email of the user's account used.
        // const email = error.customData.email;
        // The AuthCredential type that was used.
      });
  } catch (err) {
    error = err;
  }
  return { user, error, userInfo, result: credential };
}
